import { Conditional } from '@cat-ecom/pcc-components';
import PartsCheckPrice from 'components/parts-check-price/parts-check-price';
import { CatButton } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import styles from '../product-diagram-drawer.module.scss';
import {
  GA_ADD_ALL_TO_CART_CTA,
  GA_PDP_LIST_VIEW_FOOTER_SECTION,
  GA_PRIMARY_CTA
} from 'constants/analyticsConstants';

interface StickyBottomActionsProps {
  isCatCorp: boolean;
  isActiveListTab: boolean;
  shouldShowStickyContactDealer: boolean;
  shouldShowStickyAddToCart: boolean;
  stickyContactDealerBtn: React.ReactNode;
  handleAddAllToCart: () => void;
}

export const StickyBottomActions = ({
  isCatCorp,
  isActiveListTab,
  shouldShowStickyContactDealer,
  shouldShowStickyAddToCart,
  stickyContactDealerBtn,
  handleAddAllToCart
}: StickyBottomActionsProps) => {
  const t = useTranslations();

  return (
    <>
      <Conditional test={isCatCorp && isActiveListTab}>
        <div
          data-testid="parts-check-price"
          className={cx(
            styles['sticky-check-price-container'],
            'fixed-bottom w-100 p-3'
          )}
        >
          <PartsCheckPrice
            classNames="mb-0 text-capitalize"
            size="md"
            variant="contrast"
            fullWidth
          />
        </div>
      </Conditional>
      
      <Conditional test={shouldShowStickyContactDealer}>
        <div
          className={cx(
            styles['sticky-check-price-container'],
            'fixed-bottom w-100 p-3'
          )}
        >
          {stickyContactDealerBtn}
        </div>
      </Conditional>

      <Conditional test={!isCatCorp && shouldShowStickyAddToCart}>
        <div
          className={cx(
            styles['sticky-check-price-container'],
            'fixed-bottom w-100 p-3'
          )}
        >
          <CatButton
            size="md"
            className="text-capitalize"
            variant="primary"
            fullWidth
            data-testid="add-all-to-cart"
            onClick={handleAddAllToCart}
            data-track-event={GA_PRIMARY_CTA}
            data-track-attr-nltext={GA_ADD_ALL_TO_CART_CTA}
            data-track-attr-context={GA_PDP_LIST_VIEW_FOOTER_SECTION}
          >
            {t('PM_ADD_ALL_TO_CART')}
          </CatButton>
        </div>
      </Conditional>
    </>
  );
};

export default StickyBottomActions;
